import dxLogo from '../assets/image/dxinterior-logo.svg';
import dxLogoWhite from '../assets/image/dxinterior-w-logo.svg';

import loginBackground from '../assets/image/login-bg.png';

const featureCards = [
  {
    title: 'Smart Surface',
    subtitle: 'Material Swapping',
    icon: (
      <svg className="w-[24px] h-[24px]" viewBox="0 0 22 26" fill="none" aria-hidden="true">
        <path d="M16.75 4.08333H18.0833C19.5567 4.08333 20.75 4.61 20.75 6.08333V8.75C20.75 9.45724 20.469 10.1355 19.969 10.6356C19.4689 11.1357 18.7906 11.4167 18.0833 11.4167H8.75C8.39638 11.4167 8.05724 11.5571 7.80719 11.8072C7.55714 12.0572 7.41667 12.3964 7.41667 12.75V23.4167C7.41667 23.7703 7.55714 24.1094 7.80719 24.3595C8.05724 24.6095 8.39638 24.75 8.75 24.75H10.0833M16.75 4.08333V2.08333C16.75 1.72971 16.6095 1.39057 16.3595 1.14052C16.1094 0.890476 15.7703 0.75 15.4167 0.75H2.08333C1.72971 0.75 1.39057 0.890476 1.14052 1.14052C0.890476 1.39057 0.75 1.72971 0.75 2.08333V6.08333C0.75 6.43696 0.890476 6.77609 1.14052 7.02614C1.39057 7.27619 1.72971 7.41667 2.08333 7.41667H15.4167C15.7703 7.41667 16.1094 7.27619 16.3595 7.02614C16.6095 6.77609 16.75 6.43696 16.75 6.08333V4.08333Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    title: 'Seamless Scene',
    subtitle: 'Cleanup',
    icon: (
      <svg className="w-[24px] h-[24px]" viewBox="0 0 26 26" fill="none" aria-hidden="true">
        <path d="M9.46067 11.6182C9.23518 11.8437 9.05635 12.1114 8.93441 12.4061C8.81247 12.7008 8.7498 13.0166 8.75 13.3355V16.7515H12.1873C12.8313 16.7515 13.45 16.4955 13.906 16.0395L24.0393 5.90085C24.2653 5.67543 24.4446 5.40766 24.5669 5.11286C24.6892 4.81805 24.7522 4.50202 24.7522 4.18285C24.7522 3.86367 24.6892 3.54764 24.5669 3.25284C24.4446 2.95803 24.2653 2.69026 24.0393 2.46485L23.038 1.46351C22.8126 1.23735 22.5447 1.0579 22.2498 0.935465C21.9549 0.813026 21.6387 0.75 21.3193 0.75C21 0.75 20.6838 0.813026 20.3889 0.935465C20.094 1.0579 19.8261 1.23735 19.6007 1.46351L9.46067 11.6182Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M24.75 12.752C24.75 18.4093 24.75 21.2373 22.9927 22.9946C21.2353 24.752 18.406 24.752 12.75 24.752C7.094 24.752 4.26467 24.752 2.50733 22.9946C0.75 21.2373 0.75 18.408 0.75 12.752C0.75 7.09595 0.75 4.26662 2.50733 2.50929C4.26467 0.751953 7.094 0.751953 12.75 0.751953" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    title: 'Intelligent Object',
    subtitle: 'Staging',
    icon: (
      <svg className="w-[24px] h-[24px]" viewBox="0 0 26 26" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M7.41667 10.0833L12.75 12.75M7.41667 10.0833V15.4167L12.75 18.0833M7.41667 10.0833L12.75 7.41667L18.0833 10.0833M12.75 12.75L18.0833 10.0833M12.75 12.75V18.0833M12.75 18.0833L18.0833 15.4167V10.0833M9.28333 24.75C6.29667 24.75 4.80333 24.75 3.662 24.1687C2.65851 23.6573 1.84265 22.8415 1.33133 21.838C0.75 20.6967 0.75 19.2033 0.75 16.2167M24.75 16.2167C24.75 19.2033 24.75 20.6967 24.1687 21.838C23.6573 22.8415 22.8415 23.6573 21.838 24.1687C20.6967 24.75 19.2033 24.75 16.2167 24.75M16.2167 0.75C19.2033 0.75 20.6967 0.75 21.838 1.33133C22.8415 1.84265 23.6573 2.65851 24.1687 3.662C24.75 4.80333 24.75 6.29667 24.75 9.28333M9.28333 0.75C6.29667 0.75 4.80333 0.75 3.662 1.33133C2.65851 1.84265 1.84265 2.65851 1.33133 3.662C0.75 4.80333 0.75 6.29667 0.75 9.28333" />
      </svg>
    ),
  },
  {
    title: 'Photorealistic Renders',
    subtitle: '& Flythroughs',
    icon: (
      <svg className="w-[24px] h-[24px]" viewBox="0 0 26 26" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M24.6527 10.07C15.8394 8.85933 8.23941 15.4033 8.75008 24.0833M5.41675 7.41667C5.41675 8.12391 5.6977 8.80219 6.1978 9.30228C6.69789 9.80238 7.37617 10.0833 8.08341 10.0833C8.79066 10.0833 9.46894 9.80238 9.96903 9.30228C10.4691 8.80219 10.7501 8.12391 10.7501 7.41667C10.7501 6.70942 10.4691 6.03115 9.96903 5.53105C9.46894 5.03095 8.79066 4.75 8.08341 4.75C7.37617 4.75 6.69789 5.03095 6.1978 5.53105C5.6977 6.03115 5.41675 6.70942 5.41675 7.41667Z" />
        <path d="M0.75 14.1716C4.45667 13.6582 7.78333 15.4489 9.582 18.3049" />
        <path d="M0.75 9.28333C0.75 6.29667 0.75 4.80333 1.33133 3.662C1.84265 2.65851 2.65851 1.84265 3.662 1.33133C4.80333 0.75 6.29667 0.75 9.28333 0.75H16.2167C19.2033 0.75 20.6967 0.75 21.838 1.33133C22.8415 1.84265 23.6573 2.65851 24.1687 3.662C24.75 4.80333 24.75 6.29667 24.75 9.28333V16.2167C24.75 19.2033 24.75 20.6967 24.1687 21.838C23.6573 22.8415 22.8415 23.6573 21.838 24.1687C20.6967 24.75 19.2033 24.75 16.2167 24.75H9.28333C6.29667 24.75 4.80333 24.75 3.662 24.1687C2.65851 23.6573 1.84265 22.8415 1.33133 21.838C0.75 20.6967 0.75 19.2033 0.75 16.2167V9.28333Z" />
      </svg>
    ),
  },
];

const renderSamples = [1, 2, 3, 4];

const footerLinks = [
  { label: 'Modules', href: '#' },
  { label: 'Projects', href: '#' },
  { label: 'Supplier', href: '#' },
  { label: 'About', href: '#' },
  { label: 'Resources', href: '#' },
  { label: 'Contact', href: '#' },
];

const footerModules = [
  { label: 'DX Living', href: '#' },
  { label: 'DX Interiors', href: '#' },
  { label: 'DX Studio', href: '#' },
  { label: 'DX Prestige', href: '#' },
];

const socialIcons = [
  {
    name: 'Facebook',
    href: '#',
    icon: (
    <svg width="14" height="14" fill="currentColor" viewBox="1 0 16 16" aria-hidden="true">
      <path d="M7.2 16v-7.5h-2v-2.7h2c0 0 0-1.1 0-2.3 0-1.8 1.2-3.5 3.9-3.5 1.1 0 1.9 0.1 1.9 0.1l-0.1 2.5c0 0-0.8 0-1.7 0-1 0-1.1 0.4-1.1 1.2 0 0.6 0-1.3 0 2h2.9l-0.1 2.7h-2.8v7.5h-2.9z"></path>
    </svg>
    ),
  },
  {
    name: 'LinkedIn',
    href: '#',
    icon: (
    <svg width="14" height="14" fill="currentColor" viewBox="-2 -1 24 24" aria-hidden="true">
      <path d="M19.959 11.719v7.379h-4.278v-6.885c0-1.73-.619-2.91-2.167-2.91-1.182 0-1.886.796-2.195 1.565-.113.275-.142.658-.142 1.043v7.187h-4.28s.058-11.66 0-12.869h4.28v1.824l-.028.042h.028v-.042c.568-.875 1.583-2.126 3.856-2.126 2.815 0 4.926 1.84 4.926 5.792zM2.421.026C.958.026 0 .986 0 2.249c0 1.235.93 2.224 2.365 2.224h.028c1.493 0 2.42-.989 2.42-2.224C4.787.986 3.887.026 2.422.026zM.254 19.098h4.278V6.229H.254v12.869z"></path>
    </svg>
    ),
  },
  {
    name: 'Instagram',
    href: '#',
    icon: (
    <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"></path>
    </svg>
    ),
  },
  {
    name: 'YouTube',
    href: '#',
    icon: (
    <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M23,9.71a8.5,8.5,0,0,0-.91-4.13,2.92,2.92,0,0,0-1.72-1A78.36,78.36,0,0,0,12,4.27a78.45,78.45,0,0,0-8.34.3,2.87,2.87,0,0,0-1.46.74c-.9.83-1,2.25-1.1,3.45a48.29,48.29,0,0,0,0,6.48,9.55,9.55,0,0,0,.3,2,3.14,3.14,0,0,0,.71,1.36,2.86,2.86,0,0,0,1.49.78,45.18,45.18,0,0,0,6.5.33c3.5.05,6.57,0,10.2-.28a2.88,2.88,0,0,0,1.53-.78,2.49,2.49,0,0,0,.61-1,10.58,10.58,0,0,0,.52-3.4C23,13.69,23,10.31,23,9.71ZM9.74,14.85V8.66l5.92,3.11C14,12.69,11.81,13.73,9.74,14.85Z"></path>
    </svg>
    ),
  },
];

const LandingPage = () => {
  return (
    <div className="min-h-screen dashboard-gradient-surface text-slate-900">
      <header className="px-6 py-6 flex justify-center border-b border-slate-200/70 bg-white/70 backdrop-blur-sm">
        <img src={dxLogo} alt="DX Interiors" className="h-8 w-auto" />
      </header>

      <main className="px-6 py-12">
        <section className="text-center max-w-6xl mx-auto">
          <p className="tracking-[0.35em] text-xs md:text-sm text-slate-500 uppercase mt-8">
            Powered by DX Living
          </p>
          <h1 className="title-heading text-4xl md:text-[40px] text-slate-900 mt-10 mb-4">
            Your Complete AI Interior Design Studio
          </h1>
          <p className="max-w-2xl mx-auto text-slate-600 mb-8">
            From current room to your desired space. Automate the heavy lifting redesign, 
            refine, and walk through stunning photorealistic renders instantly.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="/login"
              className="inline-flex items-center justify-center px-10 py-2 rounded-full bg-[#18243c] text-white hover:bg-[#111a2e] transition-colors"
            >
              Get Started
            </a>
          </div>
        </section>

        <section className="w-max mx-auto my-20 grid grid-cols-2 md:grid-cols-4 gap-6">
          {featureCards.map((card) => (
            <div
              key={card.title}
              className="text-center"
            >
              <div className="h-[64px] w-[64px] rounded-2xl mx-auto mb-3 flex items-center justify-center text-slate-500   bg-[linear-gradient(115deg,_#ffffff47_0%,_#ffffff47_50%,_#f1f5ff_100%)] border-[#ffffff] border">
                {card.icon}
              </div>
              <p className="text-sm font-medium text-primary-300">{card.title}</p>
              <p className="text-sm text-primary-300">{card.subtitle}</p>
            </div>
          ))}
        </section>

        <section className="max-w-6xl mx-auto mt-16">
          <h2 className="title-heading text-3xl text-center mb-6">Explore Our Renders</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {renderSamples.map((sample) => (
              <div
                key={`explore-${sample}`}
                className="rounded-3xl overflow-hidden h-44 border border-slate-200 bg-white"
              >
                <img
                  src={loginBackground}
                  alt="Render preview"
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
        </section>

        <section className="max-w-6xl mx-auto mt-16">
          <h2 className="title-heading text-3xl text-center mb-6">Recent User Renders</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {renderSamples.map((sample) => (
              <div
                key={`recent-${sample}`}
                className="rounded-3xl overflow-hidden h-44 border border-slate-200 bg-white"
              >
                <img
                  src={loginBackground}
                  alt="Recent render"
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
        </section>
      </main>

      <footer className="bg-[#151f31] text-slate-200 mt-16 pt-14">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1.35fr_0.8fr_0.8fr_1fr_1.2fr] gap-8 pb-10">
          <div>
            <img src={dxLogoWhite} alt="DX Interiors" className="h-12 w-auto mb-4" />
            <p className="text-[12px] leading-5 text-slate-400 max-w-[260px]">
              We help architects and homeowners design spaces and deliver
              photorealistic visuals with AI.
            </p>
            <div className="flex items-center gap-2 mt-4">
              {socialIcons.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  aria-label={social.name}
                  className="h-8 w-8 p-2 rounded-full border border-primary-200 text-primary-200 flex items-center justify-center hover:text-white hover:border-slate-300 transition-colors"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="text-[14px] lao-mn  tracking-[0.16em] uppercase text-primary-200 mb-3">Links</p>
            <div className="space-y-2 text-sm">
              {footerLinks.map((link) => (
                <a key={link.label} href={link.href} className="block text-slate-300 hover:text-white">
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="text-[14px] lao-mn tracking-[0.16em] uppercase text-primary-200 mb-3">Our Modules</p>
            <div className="space-y-2 text-sm">
              {footerModules.map((module) => (
                <a key={module.label} href={module.href} className="block text-slate-300 hover:text-white">
                  {module.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="text-[14px] lao-mn tracking-[0.16em] uppercase text-primary-200 mb-3">Contact</p>
            <p className="text-sm text-slate-300 leading-6">
              Want to explore how DX Living can elevate your space? Get in touch
              we'd love to hear from you.
            </p>
            <p className="text-sm text-slate-200 mt-3">1800 333 509</p>
          </div>

          <div>
            <p className="text-[14px] lao-mn tracking-[0.16em] uppercase text-primary-200 mb-3">Stay In Touch</p>
            <p className="text-sm text-slate-300 mb-3">
              Subscribe for project updates and design news.
            </p>
            <div className="space-y-2">
              <input
                type="email"
                placeholder="Name"
                className="w-full bg-transparent border-0 border-b-2 border-slate-500/40 px-0 py-2 text-sm placeholder:text-slate-500 focus:outline-none focus:border-slate-300"
              />
              <input
                type="email"
                placeholder="Email"
                className="w-full bg-transparent border-0 border-b-2 border-slate-500/40 px-0 py-2 text-sm placeholder:text-slate-500 focus:outline-none focus:border-slate-300"
              />
              <div className="pt-4">
                <button
                  type="button"
                  className="inline-flex items-center justify-center rounded-full border border-primary-200 px-4 py-2 text-xs text-primary-200 tracking-[0.2em] uppercase hover:bg-slate-100 hover:text-slate-900 transition-colors"
                >
                  Sign Up Now
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-6xl mx-auto border-t border-slate-400/15">
          <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-[11px] tracking-[0.12em] uppercase text-slate-500">
            <p>2025 DX Living. All rights reserved</p>
            <div className="flex items-center gap-6">
              <a href="#" className="hover:text-slate-300">Terms &amp; Conditions</a>
              <a href="#" className="hover:text-slate-300">Privacy Policy</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
